/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';


export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks: CodeBlock[] = [];
    const project: ProjectConfiguration = feature.project;
    const node = feature as BaseNode;

    const incomingLinks = project.getNodeLinks(node, 'comp');
    const trueLinks = project.getNodeLinks(node, 'true_output');
    const falseLinks = project.getNodeLinks(node, 'false_output');
    for (let i = 0; i < incomingLinks.length; i += 1) {
        const link = incomingLinks[i];

        const op1 = project.getNodeParameter(link, 'operand1');
        let op1DataType = TibboDataType.STRING;
        let OPERATOR = project.getNodeParameter(link, 'operator');
        let op2DataType = TibboDataType.STRING;
        const op2 = project.getNodeParameter(link, 'operand2');
        const variables = project.getVariables();
        const source = project.getFeature(link.getSettingValue('SOURCE_FEATURE')) as BaseNode;
        const sourceParams = source.getPort(link.getSettingValue('SOURCE_PORT'))?.params;
        for (let j = 0; j < variables.length; j += 1) {
            const variable = variables[j];
            if (variable.getSettingValue('VARNAME') === op1) {
                op1DataType = variable.getSettingValue('DATATYPE');
                break;
            }
            if (variable.getSettingValue('VARNAME') === op2) {
                op2DataType = variable.getSettingValue('DATATYPE');
                break;
            }
        }
        if (sourceParams) {
            for (let j = 0; j < sourceParams.length; j += 1) {
                const variable = sourceParams[j];
                if (variable.name === op1) {
                    op1DataType = variable.dataType;
                    break;
                }
                if (variable.name === op2) {
                    op2DataType = variable.dataType;
                    break;
                }
            }
        }
        let op1Value = op1;
        let op2Value = op2;
        if (OPERATOR === '=') {
            if (op1DataType === TibboDataType.DATETIME
                && op2DataType === TibboDataType.TIME) {
                op1Value = project.convertDataType(op1, TibboDataType.DATETIME, TibboDataType.TIME);
            } else if (op1DataType === TibboDataType.TIME
                && op2DataType === TibboDataType.DATETIME) {
                op2Value = project.convertDataType(op2, TibboDataType.DATETIME, TibboDataType.TIME);
            }
            if (op1DataType === TibboDataType.STRING) {
                op2Value = project.parseCodeExpression(op2, sourceParams, op2DataType);
            }
        }

        // transform operators
        switch (OPERATOR) {
            case '=':
                OPERATOR = '==';
                break;
            case '<>':
                OPERATOR = '!=';
                break;
            default:
                // do nothing
                break;
        }

        blocks.push({
            location: link.getSourceId(),
            blockType: BlockType.CODE,
            id: link.getID(),
            template: `
if ${op1Value} ${OPERATOR} ${op2Value}:
    ${trueLinks.length > 0 ? `#****${trueLinks[0].getSourceId()}****#` : ''}
    pass
else:
    ${falseLinks.length > 0 ? `#****${falseLinks[0].getSourceId()}****#` : ''}
    pass`,
        });
    }

    return blocks;
};
